import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteAccommodation($companyId: ID!, $id: ID!) {
    deleteAccommodation(companyId: $companyId, id: $id) {
      accommodation {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
